function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "account-add",
  d: "M25.161,26.837a12.157,12.157,0,0,0,8.927-3.69,12.17,12.17,0,0,0,3.69-8.927,12.157,12.157,0,0,0-3.69-8.929A12.155,12.155,0,0,0,25.161,1.6a12.175,12.175,0,0,0-8.927,3.69,12.146,12.146,0,0,0-3.69,8.927,12.166,12.166,0,0,0,3.69,8.927,12.167,12.167,0,0,0,8.927,3.69Zm28.261-6.346H43.977v6.346h9.444v9.444h6.346V26.837h9.444V20.491H59.768V11.047H53.422ZM25.161,33.181A44.832,44.832,0,0,0,14.9,34.509,32.271,32.271,0,0,0,4.648,38.862Q0,41.888,0,45.727v6.346H50.322V45.727q0-3.837-4.649-6.863a32.273,32.273,0,0,0-10.255-4.353,44.815,44.815,0,0,0-10.257-1.327Z",
  transform: "translate(0 -1.601)",
  fill: "#ac1ede"
});

var SvgAccountAdd = function SvgAccountAdd(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69.212,
    height: 50.472,
    viewBox: "0 0 69.212 50.472",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAccountAdd, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/account-add.2fd3c627.svg";
export { ForwardRef as ReactComponent };